module.exports = __webpack_public_path__ + "img/pr_s.559ac543.png";